import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {rpcCall} from '../../util/rpc/rpcCalls'
import messageResource from '../../messageResource'
import {getPopupInfo, getSupportAttachmentId, getSupportEmail, getSupportText} from './selectors'
import {supportFormMode} from './constants'
import {createActionObject} from '../../redux/utils'
import {setSupportPopupInfoToLocalStorage} from './utils'

export const startLoading = createAction(ActionTypes.LOADING_START)
export const stopLoading = createAction(ActionTypes.LOADING_STOP)
export const setSupportFormPositionAction = createAction(ActionTypes.SUPPORT_FORM_POSITION_SET)

export const openSupportForm = ({positionStrategy, position = null}) => (dispatch, getState) => {
    dispatch(setSupportFormPositionAction({positionStrategy, position}))
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_OPEN))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const closeSupportForm = () => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_CLOSE))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportFormPosition = ({positionStrategy, position = null}) => (dispatch, getState) => {
    dispatch(setSupportFormPositionAction({positionStrategy, position}))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportFormMode = (mode) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_MODE_SET, mode))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportText = (text) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_TEXT_SET, text))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportAttachmentId = (id) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_ATTACHMENT_ID_SET, id))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportAttachmentName = (name) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_ATTACHMENT_NAME_SET, name))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const setSupportEmail = (email) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_EMAIL_SET, email))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}
export const resetSupportForm = () => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SUPPORT_FORM_RESET))
    setSupportPopupInfoToLocalStorage(getPopupInfo(getState()))
}

export const sendQuestion = () => (dispatch, getState) => {
    dispatch(startLoading())
    const state = getState()
    rpcCall('ContactSupportService.send', [
        getSupportText(state),
        null,
        null,
        getSupportEmail(state),
        null,
        getSupportAttachmentId(state)
    ], _handleError)
        .then(() => {
            dispatch(setSupportFormMode(supportFormMode.SUCCESS))
            dispatch(resetSupportForm())
        })
        .catch((error) => {
            dispatch(resetSupportForm())
            alert(error)
        })
}

function _handleError(error) {
    if (error.exception === 'com.actimind.common.util.PWSCommunicationException') {
        alert(messageResource.getMessage('contact_support.error.communication_exception'))
    } else if (error.exception === 'com.actimind.actitime.services.ContactSupportValidationException') {
        alert(messageResource.getMessage('contact_support.error.validation_exception'))
    } else if (error.exception === 'com.actimind.actitime.services.UploadExpiredException') {
        alert(messageResource.getMessage('contact_support.error.upload_expired_exception'))
    } else {
        alert(messageResource.getMessage('contact_support.error.generic'))
    }
    return true
}



// WEBPACK FOOTER //
// ./web/js/support/supportForm/actions.js